module.exports = __webpack_public_path__ + "img/logo.bb0b8a9f.png";